import { useState } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function ServicePacks() {
  const [action, setAction] = useState('create');
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setMessage('');
    try {
      if (action === 'create') {
        if (!name) {
          setMessage('Please provide a service pack name.');
          return;
        }

        // Do NOT send id for creation
        const packData = { name, description };
        const savedPack = await sendApiRequest('POST', '/admin/services/packs', packData);
        setMessage(`Service Pack saved: ${savedPack?.name ?? 'unknown'} (ID ${savedPack?.id ?? 'N/A'})`);
      } else if (action === 'delete') {
        if (!id) {
          setMessage('Please provide an ID to delete.');
          return;
        }
        await sendApiRequest('DELETE', `/admin/services/packs/${id}`);
        setMessage(`Service Pack with ID ${id} deleted.`);
      }

      // Reset fields
      setId('');
      setName('');
      setDescription('');
    } catch (error) {
      setMessage(error?.message ?? 'Request failed');
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Create / Update Service Pack' : 'Delete Service Pack'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Create / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <div className="editing-panel__field">
          <label>Pack ID</label>
          <input
            type="number"
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="Enter pack ID"
          />
        </div>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field">
              <label>Pack Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter service pack name"
              />
            </div>

            <div className="editing-panel__field editing-panel__field--span-2">
              <label>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Pack' : 'Save Pack'}
      message={message}
    />
  );
}
